import React, { useState, Fragment } from 'react'
import { Box } from '@material-ui/core'

import { ModalFooter } from 'Components/Modal/ModalFooter'
import SubmitButton from '../../../../Components/Form/SubmitButton/index'
import { addFlyerCodes } from '../../../../Module/graphQL'
import LoadingIndicator from '../../../../Components/LoadingIndicator/LoadingIndicator'
import LinearProgressBar from '../../../../Components/LinearProgressBar'

const ConfirmationModalBody = ({ hideReduxModal, modalCancel, flyersData }) => {
  const [isLoading, setLoading] = useState(false)
  const [progress, setProgress] = useState(0)
  const [isShowProgress, setIsShowProgress] = useState(false)

  const onProgress = ({ processedAmount, totalAmount }) => {
    setProgress(Math.floor((processedAmount / totalAmount) * 100))
  }
  const onConfirm = async () => {
    try {
      setIsShowProgress(true)
      setLoading(true)
      await addFlyerCodes(null, flyersData, onProgress)
      setLoading(false)
      hideReduxModal()
      modalCancel()
    } catch (err) {
      console.error(err)
    }
  }

  return (
    <section className="redux-modal">
      {isLoading ? (
        <Fragment>
          <Box display="flex" mb={2} justifyContent="center">
            <div style={{ color: 'red' }}>
              Closing the window before the upload is complete will corrupt the
              upload.
            </div>
          </Box>
          <LoadingIndicator
            label={`Uploading ${Number(
              flyersData.length,
            ).toLocaleString()} codes...`}
          />
        </Fragment>
      ) : (
        <article>
          <p>
            Are you sure? If you get this wrong you'll have to adjust{' '}
            <b style={{ fontSize: 'large' }}>
              {Number(flyersData.length).toLocaleString()}
            </b>{' '}
            flyer codes manually.
          </p>
        </article>
      )}
      {progress || isShowProgress ? (
        <LinearProgressBar
          variant="determinate"
          value={progress}
          showValue={true}
          isLoading={false}
          styles={{
            paddingTop: 40,
            marginRight: 8,
          }}
        />
      ) : null}
      <ModalFooter>
        <SubmitButton value="Cancel" onClick={hideReduxModal} />
        <SubmitButton
          disabled={isLoading}
          value="Confirm"
          onClick={onConfirm}
          formSubmitting={isLoading}
        />
      </ModalFooter>
    </section>
  )
}

export default ConfirmationModalBody
